import * as React from 'react'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import { appStore } from '../store'

const { RELEASE_STAGE } = process.env
const { APP_VERSION } = process.env
const { BUGSNAG_KEY } = process.env

export const bugsnagClient = Bugsnag.start({
  apiKey: BUGSNAG_KEY,
  appVersion: APP_VERSION,
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['stag', 'prod'],
  releaseStage: RELEASE_STAGE,
  metadata: {
    region: ENV.GOGOVAN_COUNTRY,
  },
  onError: event => {
    const isOffline = globalThis?.navigator.onLine === false;
    const errorMsg = event.errors[0].errorMessage.toLowerCase();
    const isNetworkError = ['network error', 'failed to fetch', 'load failed', 'net::err'].some(msg => errorMsg.includes(msg));

    if (isOffline && isNetworkError) return false;
    if (event.originalError?.response?.status === 401) return false;

    event.addMetadata('device', {
      onlineStatus: isOffline ? 'offline' : 'online',
      connectionType: navigator.connection ? navigator.connection.effectiveType : 'unknown'
    });

    const state = appStore.getStore() ? appStore.getState() : null
    const currentUser = state?.session?.currentUser
    const userId = currentUser ? currentUser.id : 'anonymous'
    const organizationId =
      userId === 'anonymous' ? null : currentUser?.organization?.id
    event.addMetadata('user', { userId, organizationId })
    
    if (event.originalError?.response) {
      event.addMetadata('request', {
        method: event.originalError.response.config?.method,
        url: `${event.originalError.response.config?.baseURL}${event.originalError.response.config?.url}`,
        headers: event.originalError.response.config?.headers,
        params: event.originalError.response.config?.params,
        data:
          event?.originalError.response.config?.url === 'users/sign_in' ? undefined : event.originalError.response.config?.data,
      })
    }
  },
})

export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(
  React
)
